import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const QRCodeIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M14.12 3.82H17.38C19.14 3.82 20.14 4.82 20.14 6.58V9.74H18.5V6.68C18.5 5.98 17.98 5.46 17.28 5.46H14.12V3.82ZM9.88 3.82V5.46H6.72C6.02 5.46 5.5 5.98 5.5 6.68V9.74H3.86V6.58C3.86 4.82 4.86 3.82 6.62 3.82H9.88ZM13.2 10.76V7.82H16.14V10.76H13.2ZM7.86 10.76V7.82H10.8V10.76H7.86ZM13 14.12V12.96H14.16V14.12H13ZM15.32 14.12V12.96H16.48V14.12H15.32ZM7.86 16.1V13.16H10.8V16.1H7.86ZM14.16 15.28V14.12H15.32V15.28H14.16ZM14.12 20.1V18.46H17.28C17.98 18.46 18.5 17.94 18.5 17.24V14.18H20.14V17.34C20.14 19.1 19.14 20.1 17.38 20.1H14.12ZM9.88 20.1H6.62C4.86 20.1 3.86 19.1 3.86 17.34V14.18H5.5V17.24C5.5 17.94 6.02 18.46 6.72 18.46H9.88V20.1ZM13 16.44V15.28H14.16V16.44H13ZM15.32 16.44V15.28H16.48V16.44H15.32Z" />
    </SvgIcon>
  );
});
